export const DB_NAME = 'texas42';

export const STORE_MATCHES = 'matches';
export const STORE_COMPLETED_HANDS = 'completedHands';
export const STORE_RULESETS = 'rulesets';
export const STORE_PREFERENCES = 'preferences';
export const STORE_ADAPTIVE_PROFILES = 'adaptiveProfiles';
export const STORE_META = 'meta';

export const APP_VERSION = '1.0.0';
export const ENGINE_VERSION = '1.0.0';

export const ALL_STORES = [
  STORE_MATCHES,
  STORE_COMPLETED_HANDS,
  STORE_RULESETS,
  STORE_PREFERENCES,
  STORE_ADAPTIVE_PROFILES,
  STORE_META,
] as const;

export type Texas42StoreName = (typeof ALL_STORES)[number];
